<template>
    <div>
        <loadings v-if="loading"></loadings>
        <template v-else>
            <headers :title="title"></headers>
            <div class="knowledg">
                <div class="con">
                    <p>{{knowledg.name}}</p>
                    <div>知识点掌握率{{knowledg.k_right_rate}}%</div>
                </div>
            </div>
            <h3 class="title">该知识点包含以下题目</h3>
            <template v-if="question.length">
                <mathCom :questions="question"
                         :type="'knowledg'"
                         :showNum="true"
                         :sid="sid"
                         v-if="sid==21||sid==22"></mathCom>
                <english :questions="question"
                         :type="'knowledg'"
                         :showNum="true"
                         :sid="sid"
                         v-else-if="sid==91||sid==92"></english>
                <chinese :questions="question"
                         :type="'knowledg'"
                         :showNum="true"
                         :sid="sid"
                         v-else></chinese>
            </template>
            <noResouse :text="'暂无试题'"
                       v-else></noResouse>
        </template>
    </div>
</template>

<script>
import headers from "COMPONENTS/base/header.vue";
import loadings from "COMPONENTS/base/loadingS.vue";
import chinese from "../wrong.vue";
import english from "../../english/wrong.vue";
import mathCom from "../../math/wrong.vue";
import noResouse from 'COMPONENTS/noResouse.vue';
export default {
    components: {
        loadings,
        noResouse,
        headers,
        chinese,
        mathCom,
        english
    },
    data () {
        return {
            title: "知识点掌握情况",
            question: [],
            cid: this.$route.query.cid,
            sid: this.$route.query.sid,
            unitId: this.$route.query.unitId,
            kid: this.$route.query.kid,
            loading: true,
            knowledg: JSON.parse(localStorage.getItem('teaTaskKnowledg')),
        }
    },
    created () {
        let data = {
            sid: this.sid,
            cid: this.cid,
            kid: this.kid,
            unit_class_id: this.unitId
        };
        this.$http.post(API_URL_ZNZY_API + '/tea/catalog_unit_knowledge_question/', data).then(res => {
            this.loading = false;
            if (res.data.response == 'ok') {
                res = res.data;
                this.question = res.data.q_list
            }
        })
    },
    mounted () { },
    methods: {}
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.knowledg {
    margin-top: 30px / $ppr;
    .con {
        width: 600px / $ppr;
        padding: 24px / $ppr 30px / $ppr;
        background: #fff;
        border-radius: 16px / $ppr;
        margin: 0 auto 30px / $ppr;
        line-height: 48px / $ppr;
        font-size: 28px / $ppr;
        p {
            line-height: 48px / $ppr;
        }
        div {
            color: #999;
            font-size: 24px / $ppr;
            line-height: 48px / $ppr;
            padding-top: 10px / $ppr;
        }
    }
}
.title {
    line-height: 60px / $ppr;
    font-size: 30px / $ppr;
    color: #3c7cfb;
    width: 660px / $ppr;
    margin: 0 auto;
}
</style>